import { render } from "./LogTaskList.vue?vue&type=template&id=9dffbcc0&scoped=true"
import script from "./LogTaskList.vue?vue&type=script&lang=js"
export * from "./LogTaskList.vue?vue&type=script&lang=js"

import "./LogTaskList.vue?vue&type=style&index=0&id=9dffbcc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dffbcc0"]])

export default __exports__